import { motion } from "framer-motion";

function DropIndicator() {
  return (
    <motion.div
      layoutId="drop-indicator"
      className="bg-sky-300 w-1 h-6 rounded-md self-center"
      id="drop-indicator"
    />
  );
}

export default DropIndicator;
